<template>
    <section class="promotionDetails">
		<Nav title="推广计划详情" />
        <section class="card_list">
            <div class="card">
                <div class="item">
                    <div class="label"><p>计划名称</p></div>
                    <div class="info"><p>{{plan.planName}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>计划状态</p></div>
                    <div class="info">
                        <p v-if="plan.planStatus == 0" style="color: #EF7A0E">待生效（支付预算后生效）</p>
                        <p v-if="plan.planStatus == 1">推广中</p>
                        <p v-if="plan.planStatus == 2">已暂停</p>
                        <p v-if="plan.planStatus == 3">已完成</p>
                        <p v-if="plan.planStatus == 4">已终止</p>
                        <p v-if="plan.planStatus == 5">已取消</p>
                    </div>
                </div>                
            </div>
            <div class="card">
                <!-- <div class="item">
                    <div class="label"><p>产品类型</p></div>
                    <div class="info">
                        <p v-if="plan.productType == 1">信用贷</p>
                        <p v-if="plan.productType == 2">车抵贷</p>
                        <p v-if="plan.productType == 3">房抵贷</p>
                        <p v-if="plan.productType == 4">消费贷</p>
                        <p v-if="plan.productType == 5">企业贷</p>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label"><p>计划预算</p></div>
                    <div class="info">
                        <p>{{plan.totalBudget | f_currency}}</p>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label"><p>日预算</p></div>
                    <div class="info"><p>{{plan.dailyBudget | f_currency}}</p></div>
                </div> -->
                <div class="item" v-if="plan.dailyTargetQuantity">
                    <div class="label"><p>日投放量</p></div>
                    <div class="info">
                        <p>{{plan.dailyTargetQuantity}}</p>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="item">
                    <div class="label"><p>实际消耗</p></div>
                    <div class="info">
                        <p>{{plan.actualConsumption | f_currency}}</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>获客数</p></div>
                    <div class="info"><p>{{plan.customerCount}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>平均获客成本</p></div>
                    <div class="info">
                        <p>{{plan.averageCustomerCost | f_currency}}</p>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="item">
                    <div class="label"><p>投放城市</p></div>
                    <div class="info">
                        <p v-if="plan.cityRangeType == 0">全国</p>
                        <p v-if="plan.cityRangeType == 1">{{plan.cityRange}}</p>
                    </div>
                </div>
                <div class="item" v-show="false">
                    <div class="label"><p>渠道级别</p></div>
                    <div class="info">
                        <p>{{plan.channelLevelRange.replace('1','A级').replace('2','B级').replace('3','C级')}}</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>投放星期</p></div>
                    <div class="info">
                        <p v-if="plan.deliveryWeekOption == 0">周一到周日</p>
                        <p v-if="plan.deliveryWeekOption == 1">周一到周五</p>
                        <p v-if="plan.deliveryWeekOption == 2">周一到周六</p>
                        <p v-if="plan.deliveryWeekOption == 3">周六除外</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>投放时段</p></div>
                    <div class="info">
                        <p v-if="plan.deliveryTimeOption == 0">00:00~24:00</p>
                        <p v-if="plan.deliveryTimeOption == 1">08:00~18:00</p>
                        <p v-if="plan.deliveryTimeOption == 2">07:00~23:00</p>
                        <p v-if="plan.deliveryTimeOption == 3">08:00~12:00</p>
                        <p v-if="plan.deliveryTimeOption == 4">14:00~18:00</p>
                    </div>
                </div>                
            </div>
            <div class="card">
                <div class="item">
                    <div class="label"><p>年龄筛选</p></div>
                    <div class="info">
                        <p v-if="plan.ageRange == 0">22~59</p>
                        <p v-if="plan.ageRange == 1">25~55</p>
                        <p v-if="plan.ageRange == 2">22~49</p>
                        <p v-if="plan.ageRange == 3">30~55</p>
                        <p v-if="plan.ageRange == 4">30~50</p>
                        <p v-if="plan.ageRange == 5">25~50</p>
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>资质筛选</p></div>
                    <div class="info">
                        <p v-if="plan.qualificationFilterCriteria == 0">无筛选</p>
                        <p v-if="plan.qualificationFilterCriteria == 1">6选1（社保、公积金、车、房、企业主、保单中至少有一项）</p>
                        <p v-if="plan.qualificationFilterCriteria == 2">3选1（车、房、公积金中至少有一项）</p>
                        <p v-if="plan.qualificationFilterCriteria == 3">必有公积金</p>
                        <p v-if="plan.qualificationFilterCriteria == 4">必有车</p>
                        <p v-if="plan.qualificationFilterCriteria == 5">必有房</p>
                        <p v-if="plan.qualificationFilterCriteria == 6">必是企业主</p>
                        <p v-if="plan.qualificationFilterCriteria == 7">必有保单</p>
                        <p v-if="plan.qualificationFilterCriteria == 8">有车或有房</p>
                        <p v-if="plan.qualificationFilterCriteria == 9">必有公积金和房</p>
                        <p v-if="plan.qualificationFilterCriteria == 10">必有公积金和房和车</p>
                        <p v-if="plan.qualificationFilterCriteria == 11">必是企业主和有房</p>
                        <p v-if="plan.qualificationFilterCriteria == 12">有车或公积金</p>
                        <p v-if="plan.qualificationFilterCriteria == 13">有房或公积金</p>
                        <p v-if="plan.qualificationFilterCriteria == 14">有车且有房</p>
                    </div>
                </div>
            </div>                        
            <div class="card">
                <div class="item">
                    <div class="label"><p>创建时间</p></div>
                    <div class="info"><p>{{plan.gmtCreate}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>更新时间</p></div>
                    <div class="info"><p>{{plan.gmtModify}}</p></div>
                </div>
            </div>                   
        </section>
        <section>
            <div class="button_area">
                <van-button v-if="plan.planStatus == 0" round block type="primary" native-type="submit" @click="payPlanBudget">立即支付预算</van-button>
                <van-button v-else round block type="primary" to="/promotion" native-type="submit">返回</van-button>
            </div>
        </section>
	</section>
</template>

<script>
import Nav from "components/Nav"
import { Dialog } from 'vant';

import promotionServer from "api/promotion";

export default {
    name: "promotionDetails",
	components: {
		Nav,
	},
    data() {
        return {
            id: 0,
            plan: {},
		};
    },
    created() {
        this.id = this.$route.params.id
        this.getInfo();
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},	
    methods: {
        getInfo() {
            promotionServer.getPlanDetails({id: this.id}).then((res) => {
                this.plan = res.data
            })
        },

        payPlanBudget() {
            promotionServer.payPlanBudget({id: this.id}).then((res) => {
                if (res.code == 1) {
                    Dialog.alert({
                        title: '支付成功',
                        message: `预算支付成功\n计划开始推广中`,
                    }).then(() => {
                        this.$router.go(-1)
                    })
                } else {
                    Dialog.confirm({
                        title: '支付失败',
                        message: `余额不足,待支付成功后开始投放计划`,
                        confirmButtonText: '去充值',
                        cancelButtonText: '取消',
                    })
                    .then(() => {
                        // on confirm
                        this.$router.push({name: 'recharge'})
                    })
                    .catch(() => {
                        // on cancel
                        this.$router.go(-1)
                    })
                }
            })
        },
    },
};
</script>

<style lang="scss">
	.promotionDetails {
		padding-top: 46px;
		padding-bottom: 100px;

        .card {
            margin-bottom: 22px;
            background-color: #FDFDFD;
            border-radius: 24px;

            .item {
                margin-left: 30px;
                padding: 16px 30px 16px 0;
                border-bottom: 1px solid #E9F0F8;
                display: flex;
                justify-content: space-between;

                .label p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #4D5B80;
                }

                .info {
                    max-width: 70%;
                }

                .info p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #000;
                    text-align: right;
                }
            }

            .item:last-child {
                border-bottom: 0;
            }
        }

        .button_area {
            position: fixed;
            bottom: 30px;
            width: 100%;
            padding: 0 28px;
        }
	}
</style>


// WEBPACK FOOTER //
// src/views/promotion/Details.vue